import React from 'react';

import './Hero.scss'

export default class Hero extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
            value: ''
        }
    }

    render() {
        return (
            <div className="hero-wrapper">
                <div className="hero">
                <span>
                    <strong>
                        PORTO
                    </strong>
                    <br/>
                    Just My Photos
                </span>
                </div>
            </div>
        )
    }

}
